import { useLayoutEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";
import Dashboard from "../../layouts/Dashboard";
import styles from "./Apps.module.scss";
/* eslint-disable-next-line */
import { useIframeAppInit } from "@pushpress/react-hooks/iframe";

// Props interface for the PushPressApp component
// src: The URL to load in the iframe
// title: The title attribute for the iframe (for accessibility)
interface PushPressAppProps {
  src: string;
  title: string;
}

// add additional query parameters apps may use here
const queryParamWhitelist = ["banner", "event_id"];

const PushPressApp = ({ src, title }: PushPressAppProps) => {
  const url = new URL(src);

  // Get the current location to access query parameters
  const { location, push } = useHistory();
  const currentParams = new URLSearchParams(location.search);

  // Prevent body scrolling while the iframe is mounted
  useRemoveBodyScroll();

  // Reference to the iframe element for postMessage communication
  const iframeRef = useRef<HTMLIFrameElement>(null);

  // Get the access token from cookies on component mount
  const [accessToken] = useState(() => Cookies.get("ACCESS_TOKEN"));

  useIframeAppInit({
    iframeRef,
    token: accessToken,
    onNavigate: (relativePath) => push(relativePath),
  });

  // Pass through current query parameters to the iframe
  currentParams.forEach((value, key) => {
    if (!queryParamWhitelist.includes(key)) return;
    url.searchParams.append(key, value);
  });

  return (
    <Dashboard>
      <div className={styles.root}>
        {/* Iframe element that fills its container */}
        <iframe
          ref={iframeRef}
          title={title}
          className={styles.frame}
          src={url.toString()}
        />
      </div>
    </Dashboard>
  );
};

// Hook to prevent body scrolling while the iframe is mounted
// This ensures the iframe takes up the full viewport without
// allowing the parent page to scroll
const useRemoveBodyScroll = () => {
  useLayoutEffect(() => {
    // Store the original overflow value
    const originalOverflow = document.body.style.overflow;

    // Prevent scrolling
    document.body.style.overflow = "hidden";

    // Restore original overflow value on unmount
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);
};

export default PushPressApp;

export type { PushPressAppProps };
